import React from "react";
import { Link } from "react-router-dom";
import "./Homepage.css";

function Homepage() {
  return (
    <div>
      <section className="sub-header">
        <p>
          Your Shop Consultant is{" "}
          <span>
            {" "}
            <u>Market America</u>{" "}
          </span>
        </p>
        <p>
          Earn up to
          <span>
            50%
            <img
              src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
              width="12px"
              alt=""
            />
            Cashback
          </span>
          on eligible purchases.{" "}
          <span>
            {" "}
            <u>Learn More</u>{" "}
          </span>
        </p>
      </section>

      <section className="cashback-container">
        <p>
          $50,073,228 <span> awarded in </span>
          <img
            src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
            width="30px"
            alt=""
          />
          <span id="cash"> Cashback </span>
        </p>
        <button>Learn More</button>
      </section>

      <section className="hero-banner">
        <img
          src="https://img.shop.com/Image/homepage/shop-usa-101197-fathers-day-esdfsdfsfxpress-shipping-socialmedia-hero1655216285067.jpeg"
          alt=""
        />
      </section>

      <section className="recommended-tiles">
        <div className="recommended-tiles-item">
          <p>Recently Viewed</p>
          <div className="recommended-tiles-item-img">
            <img
              src="https://img.shop.com/Image/290000/291400/291474/products/1926928560.jpg?size=600x600"
              alt=""
            />
          </div>
          <Link to="">Browsing History</Link>
        </div>
        <div className="recommended-tiles-item">
          <p>Dr Deedra Mason's Essential 9</p>
          <div className="recommended-tiles-item-img">
            <img
              src="https://img.shop.com/Image/homepage/us_eng_essential9_sq1616511735959.jpg"
              alt=""
            />
          </div>
          <Link to="">View the essential 9</Link>
        </div>
        <div className="recommended-tiles-item">
          <p>Featured one cart store</p>
          <div className="recommended-tiles-item-img small-img">
            <img
              src="https://img.shop.com/Image/topbrands/nmlogos_137973.gif"
              alt=""
            />
            <img
              src="https://img.shop.com/Image/topbrands/nmlogos_105090.gif"
              alt=""
            />
            <img
              src="https://img.shop.com/Image/topbrands/nmlogos_138690.gif"
              alt=""
            />
            <img
              src="https://img.shop.com/Image/topbrands/nmlogos_135882.gif"
              alt=""
            />
          </div>
          <Link to="">see more stores</Link>
        </div>
        <div className="recommended-tiles-item">
          <div className="recommended-tiles-item-img">
            <img
              src="https://img.shop.com/Image/homepage/us-en-fathersday-banner-square-cs97556-may221652106174408.jpeg"
              alt=""
            />
          </div>
        </div>
      </section>

      <section className="personalized-wrapper">
        <div className="left-personalized-wrapper">
          <img
            src="https://img.shop.com/Image/homepage/ldv-hommes-usa-eng-chi-101204-cta-banners-bigsq1654021712925.jpg"
            alt=""
          />
        </div>

        <div className="right-personalized-wrapper">
          <div className="personalized-wrapper-card">
            <div className="personalized-wrapper-card-img">
              <img
                src="https://img.shop.com/Image/homepage/nike_140x110-img.gif"
                alt=""
              />
            </div>
          </div>
          <div className="personalized-wrapper-card">
            <div className="personalized-wrapper-card-img">
              <img
                src="https://img.shop.com/Image/homepage/michaelkors_140x110-img.gif"
                alt=""
              />
            </div>
          </div>
          <div className="personalized-wrapper-card">
            <div className="personalized-wrapper-card-img">
              <img
                src="https://img.shop.com/Image/homepage/coach_brand7.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="personalized-wrapper-card">
            <div className="personalized-wrapper-card-img">
              <img
                src="https://img.shop.com/Image/homepage/MA_Grad_mp-16867-media-hp-may221651073808785.jpg"
                alt=""
              />
            </div>
            <h4>
              9%
              <img
                src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                width="15px"
                alt=""
              />
              Cashback
            </h4>
          </div>
          <div className="personalized-wrapper-card">
            <div className="personalized-wrapper-card-img">
              <img
                src="https://img.shop.com/Image/homepage/shop-usa-101151-pride-month-med1654266182082.jpeg"
                alt=""
              />
            </div>
          </div>
          <div className="personalized-wrapper-card">
            <div className="personalized-wrapper-card-img">
              <img
                src="https://img.shop.com/Image/homepage/shop-us-100695-maic2022-ticket-banners-media1650570969507.jpeg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section id="featured">
        <p>Featured Categories</p>
        <div className="fashion">
          <div className="fashion-section">
            <Link to="">
              <div className="imgDiv">
                <img
                  src="https://img.shop.com/Image/260000/266700/266794/products/1920629487.jpg?size=400x400"
                  alt=""
                />
              </div>
            </Link>
            <h4>WOMEN'S CLOTHING</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/240000/243400/243406/products/1871564145.jpg?size=400x400"
                alt=""
              />
            </div>
            <h4>MEN'S CLOTHING</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/240000/248200/248295/products/1919935435.jpg?size=400x400"
                alt=""
              />
            </div>
            <h4>GIRL'S CLOTHING</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/270000/274900/274929/products/1907370742.jpg?size=400x400"
                alt=""
              />
            </div>
            <h4>BOY'S CLOTHING</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/270000/273200/273200/products/1899581989.jpg?size=400x400"
                alt=""
              />
            </div>
            <h4>ACCESSORIES</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/240000/243400/243406/products/1922216435.jpg?size=400x400"
                alt=""
              />
            </div>
            <h4>SHOES</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/240000/243400/243406/products/1715279320.jpg?size=400x400"
                alt=""
              />
            </div>
            <h4>BEDDING</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/240000/243500/243545/products/1910446952.jpg?size=400x400"
                alt=""
              />
            </div>
            <h4>KITCHEN DINING</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/280000/281900/281909/products/1842390513.jpg?size=400x400"
                alt=""
              />
            </div>
            <h4>ELECTRONICS</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/240000/243300/243380/products/1436234961.jpg?size=750x750"
                alt=""
              />
            </div>
            <h4>BEAUTY</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://images.shop.com/pim/13009/image_j/OPC-3.JPG"
                alt=""
              />
            </div>
            <h4>HEALTH AND NUTRITION</h4>
          </div>
          <div className="fashion-section">
            <div className="imgDiv">
              <img
                src="https://img.shop.com/Image/250000/250100/250199/products/1787558026.jpg?size=750x750"
                alt=""
              />
            </div>
            <h4>KIDS</h4>
          </div>
        </div>
      </section>

      <section className="cashback">
        <div className="card">
          <img
            src="https://img.shop.com/Image/homepage/ix-usa-eng-91613-prime-ultimate-longevity-banner-media1654195508865.jpg"
            alt=""
          />
          <h4>
            2%
            <span>
              <img
                src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                width="15px"
                alt=""
              />
            </span>
            Cashback
          </h4>
        </div>
        <div className="card">
          <img
            src="https://img.shop.com/Image/homepage/shopping-annuity-sgp-eng-101356-Razors-banner-media1654197028299.jpg"
            alt=""
          />
          <h4>
            2%
            <span>
              <img
                src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                width="15px"
                alt=""
              />
            </span>
            Cashback
          </h4>
        </div>
        <div className="card">
          <img
            src="https://img.shop.com/Image/homepage/shopping-annuity-usa-101433-wellbeing-tea-media1654197047571.jpg"
            alt=""
          />
          <h4>
            2%
            <span>
              <img
                src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                width="15px"
                alt=""
              />
            </span>
            Cashback
          </h4>
        </div>
      </section>
      <section id="web-prices"></section>
      <section className="cashback">
        <div className="card">
          <img
            src="https://img.shop.com/Image/homepage/us-en-skipsgarage-evergreen-banner-mp16622-jan221642004294731.png"
            alt=""
          />
          <h4>
            6%
            <span>
              <img
                src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                width="15px"
                alt=""
              />
            </span>
            Cashback
          </h4>
        </div>
        <div className="card">
          <img
            src="https://img.shop.com/Image/homepage/us-en-naturgin-freeshipping-banner-mp16622-jan221642004667057.jpeg"
            alt=""
          />
          <h4>
            6%
            <span>
              <img
                src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                width="15px"
                alt=""
              />
            </span>
            Cashback
          </h4>
        </div>
        <div className="card">
          <img
            src="https://img.shop.com/Image/homepage/us-en-luxlair-freeshipping-banner-mp166381638985152501.jpeg"
            alt=""
          />
          <h4>
            8%
            <span>
              <img
                src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                width="15px"
                alt=""
              />
            </span>
            Cashback
          </h4>
        </div>
      </section>
      <section id="health">
        <p>Cleaning & Health Have Never Been More Important</p>
        <div className="health-products">
          <div className="health-card">
            <div className="health-card-img">
              <img
                src="https://img.shop.com/Image/210000/214100/214196/products/561800345.jpg?size=300x300"
                alt=""
              />
            </div>
            <p>Isotonix &reg; Vitamin D with K2</p>
            <h5>$33.50-$79.95</h5>
            <p>
              + upto $1.60/2%
              <span>
                <img
                  src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                  width="15px"
                  alt=""
                />
              </span>
              Cashback
            </p>
            <p className="yellow">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>(1)
            </p>
            <p>Free Shipping with $99 orders</p>
          </div>
          <div className="health-card">
            <div className="health-card-img">
              <img
                src="https://img.shop.com/Image/250000/250100/250199/products/1332818472.jpg?size=300x300"
                alt=""
              />
            </div>
            <p>DNA Miracles Isotonix &reg; Immune</p>
            <h5>$22.50</h5>
            <p>
              + $0.45/2%
              <span>
                <img
                  src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                  width="15px"
                  alt=""
                />
              </span>
              Cashback
            </p>
            <p className="yellow">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>(8)
            </p>
            <p>Free Shipping with $99 orders</p>
          </div>
          <div className="health-card">
            <div className="health-card-img">
              <img
                src="https://img.shop.com/Image/210000/214200/214267/products/559010729.jpg?size=300x300"
                alt=""
              />
            </div>
            <p>ClearShield &reg; Maximum protection and hydration</p>
            <h5>$13.95-$19.95</h5>
            <p>
              + upto $1.60/2%
              <span>
                <img
                  src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                  width="15px"
                  alt=""
                />
              </span>
              Cashback
            </p>
            <p className="yellow">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>(38)
            </p>
            <p>Free Shipping with $99 orders</p>
          </div>
          <div className="health-card">
            <div className="health-card-img">
              <img
                src="https://img.shop.com/Image/210000/214100/214196/products/561800360.jpg?size=300x300"
                alt=""
              />
            </div>
            <p>Isotonix &reg; Vitamin C</p>
            <h5>$15.95-$34.50</h5>
            <p>
              + upto $1.60/2%
              <span>
                <img
                  src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                  width="15px"
                  alt=""
                />
              </span>
              Cashback
            </p>
            <p className="yellow">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>(1)
            </p>
            <p>Free Shipping with $99 orders</p>
          </div>
        </div>
      </section>
      <section id="brands">
        <h2>Our Brands</h2>
        <div className="brand-products">
          <div className="brand-card">
            <p>HEALTH AND NUTRITION</p>
            <div className="brand-card-img">
              <img
                src="https://img.shop.com/Image/homepage/healthnutirtion1572880380738.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="brand-card">
            <p>BEAUTY</p>
            <div className="brand-card-img">
              <img
                src="https://img.shop.com/Image/homepage/lipstick1572880828301.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="brand-card">
            <p>HOME AND CLEANING</p>
            <div className="brand-card-img">
              <img
                src="https://img.shop.com/Image/homepage/home_ma1572880950379.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="brand-card">
            <p>BABY AND KIDS</p>
            <div className="brand-card-img">
              <img
                src="https://img.shop.com/Image/homepage/baby-kids1572881179463.jpg"
                alt=""
              />
            </div>
          </div>
          <div className="brand-card">
            <p>JEWELRY</p>
            <div className="brand-card-img">
              <img
                src="https://img.shop.com/Image/homepage/1840336563__225x225-img__.jpg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Homepage;
